import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import UnpublishedIcon from "@mui/icons-material/Unpublished"
import { Box, Divider, Typography } from "@mui/material"
import { DeviceResultsList } from "components/DeviceResultsList/DeviceResultsList"
import { MiniGalery } from "components/MiniGalery.tsx/MiniGalery"
import { CriteriaCatalog, TestData } from "graphql/types"

type TaskTestFollowUpCardProps = {
  testData: TestData
  criteriaCatalog: CriteriaCatalog[]
}

export const TaskTestFollowUpCard = (props: TaskTestFollowUpCardProps) => {
  const { testData, criteriaCatalog } = props
  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "row", gap: 0.5 }}>
        <Typography variant="body2">Visueller Check: </Typography>
        <Typography variant="body2">
          {testData.visualCheck ? (
            <CheckCircleIcon sx={{ color: "green", fontSize: 18 }} />
          ) : (
            <UnpublishedIcon sx={{ color: "red", fontSize: 18 }} />
          )}
        </Typography>
      </Box>

      <Typography variant="body2">{testData.description}</Typography>

      <MiniGalery images={testData.image} deleteButton={false} />

      <Divider sx={{ mt: -2 }} />

      {testData.deviceTestData?.map((item) => (
        <Box key={item.device.id} sx={{ mt: 1 }}>
          <DeviceResultsList deviceTestData={item} criteriaCatalog={criteriaCatalog} />
          <Typography variant="body2">{item.note}</Typography>

          <MiniGalery images={item.images} deleteButton={false} />
          <Divider sx={{ mt: -2 }} />
        </Box>
      ))}
    </>
  )
}
